import { NgModule } from '@angular/core';
import { ApiDebugService } from './api-debug.service';
import { DebugComparerComponent } from './comparer/comparer.component';
import { JsonComponent } from './json/json.component';
import { DebugReportInfoComponent } from './report-info/report-info.component';

const components = [JsonComponent, DebugReportInfoComponent, DebugComparerComponent];

@NgModule({
  imports: components,
  exports: components,
  providers: [ApiDebugService],
})
export class DebugModule {}
